export interface ZoneMetadata {
  entityTreeName?: string;
  entityTreeTransId?: string;
  structureType?: string;
  entityTypeName?: string;
  entityTypeTransId?: string;
}

export interface Zone {
  name: string;
  transIds: string[];
  metadata: ZoneMetadata;
}

export interface ContractAlert {
  beginDate: string;
  creationDate: string;
  endDate: string;
  name: string;
  transId: string;
  zones: Zone[];
  blocking: string[];
}

export enum NO_ZONE_ACCESS {
  MESSAGE = 'ALERTS.no_zone_access_message',
  CATEGORY = 'ALERTS.no_zone_access_category',
  ALERT_NAME = 'noAccessAlert',
  ZONE_NAME = 'noAccessZone'
}
